<script setup lang="ts">
import type { KanbanLogActor } from '@entities/kanban-comment'

import { AppText, AppTextLink } from '@shared/ui/typography'

import { useKanbanLogItemInfo } from '../../model/log/use-kanban-log-item-info.hook'

defineOptions({
  name: 'KanbanLogItemInfo',
})

const props = defineProps<{
  actor: KanbanLogActor | null
  label: string
}>()

const {
  refActorName,
  refActorUrl,
} = useKanbanLogItemInfo({
  actor: props.actor,
})
</script>

<template>
  <div class="kanban-log-item-info">
    <AppTextLink
      v-if="refActorUrl"
      name="body2-medium"
      color="blue-700"
      :href="refActorUrl"
      target="_blank"
    >
      {{ refActorName }}
    </AppTextLink>
    <AppText
      v-else
      name="body2-medium"
      color="blue-700"
    >
      {{ refActorName }}
    </AppText>
    <AppText
      name="body2"
      color="slate-500"
    >
      {{ label }}
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./KanbanLogItemInfo.scss" />